var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nibnut-heatmap"},_vm._l((_vm.cells),function(cell){return _c('div',{key:cell.id,class:{ 'out-of-range': cell.out_of_range, tooltip: !!cell.tooltip },style:({ 'background-color': cell.color }),attrs:{"data-tooltip":cell.tooltip}},[_c('label',[_vm._v(_vm._s(cell.day.format("D")))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }